/*
 * Defesa em profundidade contra XSS em links vindos do brand-config (cards da tela pré-chat).
 * O painel já valida a URL, mas o widget a renderiza/abre → validamos o esquema aqui também.
 *
 * Allowlist: http, https, mailto, tel. URL relativa (sem esquema) é considerada segura.
 * Qualquer outro esquema (javascript:, data:, vbscript:, ...) → null (link inerte).
 */
const ALLOWED_SCHEMES = new Set(["http", "https", "mailto", "tel"]);

export const safeLinkHref = (url: string | undefined | null): string | null => {
    const trimmed = (url || "").trim();
    if (!trimmed) {
        return null;
    }

    // URL protocol-relative (`//host`) herda o esquema da página e escapa do allowlist → trata como externa não permitida.
    if (trimmed.startsWith("//")) {
        return null;
    }

    // Captura o esquema (parte antes do primeiro ":") se houver. Sem esquema = URL relativa (segura).
    const schemeMatch = trimmed.match(/^([a-zA-Z][a-zA-Z0-9+.-]*):/);
    if (schemeMatch) {
        const scheme = schemeMatch[1].toLowerCase();
        if (!ALLOWED_SCHEMES.has(scheme)) {
            return null;
        }
    }

    return trimmed;
};
